import { Dispatch, SetStateAction } from "react";
import { Button, ButtonSize, ButtonVariant } from "shared/components/Button";
import { toMoney } from "shared/utils";
import { Stat } from "views/applications-id-report/components/Stat";
import { mapIncomeSourceStatus } from "views/applications-id-report/slices/CombinedIncomeReportSlice/helpers";
import { CombinedIncome } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/income";
import { VerifiedItem } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/verified";
import { getMonthlyAmount } from "views/applications-id-report/slices/CombinedIncomeReportSlice/utils";

export const IncomeSliceHeader = ({
  income,
  currentItem,
  setShowEditIncomeModal
}: {
  income: CombinedIncome;
  currentItem?: VerifiedItem;
  setShowEditIncomeModal: Dispatch<
    SetStateAction<
      | false
      | {
          grossMonthlyIncomeCents: number;
          netMonthlyIncomeCents: number;
          hasNetMonthlyIncome: boolean;
          incomeId?: number;
          isTotal: boolean;
        }
    >
  >;
}) => {
  const { status } = mapIncomeSourceStatus(income);
  const isRejected = status === "Rejected";
  const verifiedNetMonthly =
    income.additional_data?.overrides?.net_monthly_income !== undefined
      ? income.additional_data.overrides.net_monthly_income
      : income.verified_monthly_amounts.net;

  return (
    <div className="flex items-start">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <Stat
          title="Verified gross monthly"
          value={
            isRejected && !income.verified_monthly_amounts.gross
              ? "-"
              : toMoney(income.verified_monthly_amounts.gross || 0)
          }
        />
        <Stat
          title="Verified net monthly"
          value={
            isRejected && !verifiedNetMonthly
              ? "-"
              : toMoney(verifiedNetMonthly)
          }
        />
        <Stat
          title="Self-reported gross monthly"
          value={toMoney(
            getMonthlyAmount(income.amount_cents, income.pay_period) / 100
          )}
        />
      </div>

      <Button
        variant={ButtonVariant.TEXT}
        className="shrink-0"
        size={ButtonSize.SM}
        onClick={() => {
          let netMonthlyIncomeCents = 0;

          if (currentItem && currentItem.data)
            if ("net_monthly_income" in currentItem.data)
              netMonthlyIncomeCents =
                currentItem.data.net_monthly_income?.cents || 0;
            else if ("net_monthly_income_amount" in currentItem.data)
              netMonthlyIncomeCents =
                currentItem.data.net_monthly_income_amount * 100;

          setShowEditIncomeModal({
            grossMonthlyIncomeCents:
              income.additional_data?.overrides?.gross_monthly_income !==
              undefined
                ? income.additional_data.overrides.gross_monthly_income * 100
                : income.amount_cents,
            netMonthlyIncomeCents:
              income.additional_data?.overrides?.net_monthly_income !==
              undefined
                ? income.additional_data.overrides.net_monthly_income * 100
                : netMonthlyIncomeCents,
            hasNetMonthlyIncome: income.type !== "offer_letter",
            incomeId: income.id,
            isTotal: false
          });
        }}
      >
        Edit income source
      </Button>
    </div>
  );
};
